// @ts-nocheck
import {Column} from 'react-table'
import {InfoCell} from './InfoCell'
import {StatusCell} from './StatusCell'
import {CustomHeader} from './CustomHeader'
import {Authors} from '../../core/_models'
import { ActionsCell } from './ActionsCell'
import { GenericCell } from './GenericCell'

const categoriesColumns: ReadonlyArray<Column<Authors>> = [
  // {
  //   Header: (props) => <UserSelectionHeader tableProps={props} />,
  //   id: 'selection',
  //   Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index].id} />,
  // },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Id' className='min-w-25px' />
    ),
    id: 'id',
    Cell: ({...props}) => <GenericCell labelName={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Nome' className='min-w-125px' />
    ),
    id: 'name',
    Cell: ({...props}) => <InfoCell guardians={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Status' className='min-w-90px' />
    ),
    id: 'status_name',
    Cell: ({...props}) => <StatusCell guardians={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='ID.Criança' className='min-w-90px' />
    ),
    id: 'children_id',
    Cell: ({...props}) => <GenericCell labelName={props.data[props.row.index].children_id} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Criança' className='min-w-90px' />
    ),
    id: 'children_name',
    Cell: ({...props}) => <GenericCell labelName={props.data[props.row.index].children_name} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Ações' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <ActionsCell
        id={props.data[props.row.index].id}
      />
    ),
  },
]

export {categoriesColumns}
